import type { StockUnit } from "./types";

const round = (n: number, digits = 2) =>
  Number.isInteger(n) ? String(n) : n.toFixed(digits).replace(/\.?0+$/, "");

/**
 * Shows a base-unit quantity the way staff count it: the largest named unit
 * first, then the remainder in the base unit. 53 cans with a "case" of 24 →
 * "2 case + 5 piece"; 3300 ml with a 750 ml "bottle" → "4 bottle + 300 ml".
 * Negative stock (a shop that hasn't counted yet) is shown as a plain number.
 */
export function formatQty(qty: number, baseUnit: string, units: StockUnit[]): string {
  if (qty <= 0 || units.length === 0) return `${round(qty)} ${baseUnit}`;

  const largest = [...units].sort((a, b) => b.base_qty - a.base_qty)[0];
  const whole = Math.floor(qty / largest.base_qty);
  const rest = qty - whole * largest.base_qty;
  if (whole === 0) return `${round(qty)} ${baseUnit}`;
  if (rest < 1e-9) return `${whole} ${largest.name}`;
  return `${whole} ${largest.name} + ${round(rest)} ${baseUnit}`;
}
